var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "feeds"
  }, [_vm._m(0), _vm.loading ? _c('Loader', {
    class: 'widget-loader',
    attrs: {
      "size": 40
    }
  }) : _c('div', {
    staticClass: "feeds__actions-wrapper"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "feeds__actions-wrapper-item"
  }, [_c('div', {
    staticClass: "pull-model__status mr-2"
  }, [_c('span', {
    staticClass: "feeds__status-text"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-globe inline"
  }), _vm._v(" Assets: "), Object.keys(_vm.tokensData).length > 0 ? _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(Object.keys(_vm.tokensData).length))]) : _c('vue-loaders-ball-beat', {
    attrs: {
      "color": "var(--redstone-red-color)",
      "scale": "0.5"
    }
  })], 1)])]), _c('div', {
    staticClass: "token-type-filter"
  }, [_c('DropdownPicker', {
    staticClass: "feeds__token-picker",
    attrs: {
      "items": _vm.tokenTypeItems,
      "buttonTextAll": "Asset types",
      "buttonTextSelected": "Selected types"
    },
    on: {
      "input": _vm.handleTokenTypeChange
    },
    model: {
      value: _vm.selectedTokenTypes,
      callback: function callback($$v) {
        _vm.selectedTokenTypes = $$v;
      },
      expression: "selectedTokenTypes"
    }
  })], 1), _c('div', {
    staticClass: "feeds__actions-wrapper-label text-light fw-normal",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('span', {
    staticClass: "feeds__status-text mb-2"
  }, [_vm._v(" Tokens per page: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.perPage,
      expression: "perPage"
    }],
    staticClass: "feeds__select",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.onPerPageChange]
    }
  }, _vm._l(_vm.perPageOptions, function (option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(" " + _vm._s(option) + " ")]);
  }), 0)]), _c('span', {
    staticClass: "feeds__status-text",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(" Current page: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentPage,
      expression: "currentPage"
    }],
    staticClass: "feeds__select",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.currentPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.onSelectedPageChange]
    }
  }, _vm._l(_vm.availablePages, function (page) {
    return _c('option', {
      key: page,
      domProps: {
        "value": page
      }
    }, [_vm._v(" " + _vm._s(page) + " ")]);
  }), 0)])])]), _vm.hasFiltersAndSearch ? _c('div', {
    staticClass: "clear-filters",
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v(" Clear all ")]) : _vm._e(), _vm.loading ? _c('div', {
    staticClass: "loading-container"
  }, [_c('vue-loaders-ball-beat', {
    attrs: {
      "color": "var(--redstone-red-color)",
      "scale": "1"
    }
  })], 1) : _vm._e(), !_vm.loading && _vm.tokensData ? _c('b-table', {
    ref: "tokensTable",
    staticClass: "feeds__table",
    attrs: {
      "id": "tokens-table",
      "stacked": "md",
      "hover": "",
      "items": _vm.filteredTokens,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "filter": _vm.filters,
      "filter-function": _vm.customFilter,
      "sort-icon-left": "",
      "sticky-header": "500px"
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('img', {
          staticClass: "token-logo",
          attrs: {
            "src": data.item.logoURI || _vm.logoPlaceholder
          }
        }), _c('RouterLink', {
          attrs: {
            "to": {
              name: 'TokenPage',
              params: {
                symbol: data.item.symbol.includes('/') ? data.item.symbol.replace('/', '-') : data.item.symbol
              }
            }
          }
        }, [_c('span', {
          staticClass: "token-name ml-3"
        }, [_vm._v(_vm._s(data.item.name || data.item.symbol))])])];
      }
    }, {
      key: "cell(symbol)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "text-truncate text-center d-block",
          attrs: {
            "title": data.item.symbol
          }
        }, [_vm._v(" " + _vm._s(data.item.symbol) + " ")])];
      }
    }, {
      key: "cell(price)",
      fn: function fn(data) {
        var _vm$denominationMap$d;
        return [data.item.price ? _c('strong', {
          staticStyle: {
            "font-weight": "500"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.parseToCurrency(data.item.price, (_vm$denominationMap$d = _vm.denominationMap[data.item.symbol]) === null || _vm$denominationMap$d === void 0 ? void 0 : _vm$denominationMap$d.denomination, data.item.symbol))
          }
        }) : _c('span', {
          staticClass: "feeds__no-data"
        }, [_vm._v("no-data")])];
      }
    }, {
      key: "cell(tags)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex tag-wrapper"
        }, _vm._l(data.item.tags, function (tag) {
          return _c('span', {
            key: tag,
            staticClass: "tag-badge mr-1",
            on: {
              "click": function click($event) {
                return _vm.selectTag(tag);
              }
            }
          }, [_vm._v(" " + _vm._s(tag) + " ")]);
        }), 0)];
      }
    }], null, false, 2665421869)
  }) : _vm._e(), !_vm.loading ? _c('b-pagination', {
    staticClass: "my-3 custom-pagination",
    attrs: {
      "prev-text": _vm.prevIcon,
      "next-text": _vm.nextIcon,
      "limit": "1",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "fill"
    },
    on: {
      "change": _vm.onPageChange
    },
    scopedSlots: _vm._u([{
      key: "page",
      fn: function fn(_ref) {
        var page = _ref.page;
        return [page === _vm.currentPage ? _c('span', {
          staticClass: "entry-info"
        }, [_vm.totalRows > 0 ? _c('span', [_vm._v(" Showing " + _vm._s(_vm.displayFirstEntry) + " to " + _vm._s(_vm.displayLastEntry) + " of " + _vm._s(_vm.totalRows) + " entries ")]) : _c('span', [_vm._v(" No entries found "), _vm.hasFiltersAndSearch ? _c('span', [_vm._v(" - ")]) : _vm._e(), _vm.hasFiltersAndSearch ? _c('span', {
          staticClass: "clear-filters",
          staticStyle: {
            "pointer-events": "all"
          },
          on: {
            "click": _vm.resetFilters
          }
        }, [_vm._v(" Clear filters ")]) : _vm._e()])]) : _c('span', [_vm._v(_vm._s(page))])];
      }
    }], null, false, 1250184753),
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1)])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "feeds__view-details"
  }, [_c('h1', [_vm._v("RedStone Data Feeds")]), _c('p', [_vm._v(" Explore RedStone blockchain oracle database of assets with pricing from multiple sources.. ")])]);

}]

export { render, staticRenderFns }